import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BugReportIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bug_report"}/>
}
